import { VisibilityOffOutlined, VisibilityOutlined } from "@mui/icons-material";
import { IconButton, Link, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../app/hook";
import {
  OutlinedCheckbox,
  OutlinedTextField,
  SubmitButton,
} from "../../../components/form";
import { useLoginStyles } from "../css";
import { authError } from "../selectors/authSelectors";
import { doLogIn } from "../slices/authSlice";
import { clearUserDetails } from "../slices/userSlice";

const initialValues = { usernameMSCAN: "", passwordMSCAN: "" };
const subscription = { submitError: true, submitting: true };
const linkChangePassword = `${window.__ENV.REACT_APP_LINK_TO_CHNG_PASSWORD}?app=mscan`;

function LoginForm() {
  const { classes } = useLoginStyles();
  const dispatch = useAppDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const loginError = useAppSelector(authError);
  const [translate] = useTranslation();
  const tooltipLabel = showPassword
    ? translate("hidePassword", "Slėpti slaptažodį")
    : translate("showPassword", "Rodyti slaptažodį");

  const onSubmit = React.useCallback(
    (values: { usernameMSCAN: string; passwordMSCAN: string; rememberMe?: boolean }) => {
      dispatch(
        doLogIn(
          values.usernameMSCAN,
          values.passwordMSCAN,
          values.rememberMe || false
        )
      );
    },
    [dispatch]
  );

  const handleShowClick = React.useCallback(() => {
    setShowPassword(!showPassword);
  }, [showPassword]);

  useEffect(() => {
    dispatch(clearUserDetails());
    localStorage.removeItem("lastUser");
  }, []);

  return (
    <div>
      <Form
        initialValues={initialValues}
        onSubmit={onSubmit}
        subscription={subscription}
      >
        {({ handleSubmit, submitError }) => (
          <form onSubmit={handleSubmit} method="post">
            {submitError && (
              <Typography color="error">{submitError}</Typography>
            )}

            <div className={classes.root}>
              <div className={classes.spacing}>
                <OutlinedTextField
                  type="text"
                  name="usernameMSCAN"
                  label={translate("username", "Vartotojas")}
                  autoComplete="username"
                  InputLabelProps={{ shrink: true }}
                  autoFocus
                />
              </div>
              <div className={classes.spacing05}>
                <OutlinedTextField
                  type={showPassword ? "text" : "password"}
                  name="passwordMSCAN"
                  autoComplete="current-password"
                  label={translate("password", "Slaptažodis")}
                  InputLabelProps={{ shrink: true }}
                  endAdornment={
                    <Tooltip title={tooltipLabel}>
                      <IconButton onClick={handleShowClick} size="large">
                        {showPassword ? (
                          <VisibilityOutlined fontSize="small" />
                        ) : (
                          <VisibilityOffOutlined fontSize="small" />
                        )}
                      </IconButton>
                    </Tooltip>
                  }
                />
              </div>
              <div className={classes.spacing}>
                <OutlinedCheckbox
                  name="rememberMe"
                  label={translate("rememberMe", "Prisiminti mane")}
                  slotProps={{ typography: { fontSize: "12px" } }}
                />
              </div>
              {loginError ? (
                <div className={classes.spacing}>
                  <Typography color="error" className={classes.errorText}>
                    {translate(
                      "wrongPassword",
                      "Neteisingai nurodytas vartotojo vardas ar slaptažodis"
                    )}
                  </Typography>
                </div>
              ) : (
                ""
              )}

              <div className={classes.submitButton}>
                <SubmitButton>{translate("login", "Prisijungti")}</SubmitButton>
              </div>
            </div>
          </form>
        )}
      </Form>
      <div className={classes.password}>
        <Link color="inherit" underline="none" href={linkChangePassword}>
          {translate("forgotPassword", "Pamiršote slaptažodį?")}
        </Link>
      </div>
    </div>
  );
}

export default LoginForm;
